import styled from 'styled-components'

import { ContentPagePaddingCSS } from '@/layout/components/content-page-layout/ContentPageLayout.styled'

const StBottomSheetBackdrop = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  backdrop-filter: blur(2px);

  background-color: ${({ theme }) => theme.Components.Modal.Backdrop};
`

const StBottomSheetContentContainer = styled.div<{
  notSelectable: boolean
  draggable?: boolean
  fitContent?: boolean
}>`
  border-radius: 1rem 1rem 0 0;

  background: ${({ theme }) => theme.Colors.Neutrals.Lightest};

  position: relative;
  overflow-y: hidden;

  transition: ${({ notSelectable }) =>
    notSelectable ? `transform 0.25s, border-radius 0.25s` : `transform 0.25s, border-radius 0.25s, height 0.25s`};

  transform: translateY(0);

  ${({ fitContent }) =>
    fitContent
      ? `height: auto; max-height: 90vh; display: flex; flex-direction: column;`
      : `height: 30vh; max-height: 100vh;`}

  max-width: 70rem;

  box-sizing: border-box;
  padding: 1rem;
  padding-top: ${({ draggable, theme }) => (draggable ? theme.UI.SpacingPx.Space16 : theme.UI.SpacingPx.Space8)};
  padding-bottom: max(var(--safe-area-inset-bottom), 20px);
`

const StBottomSheetContent = styled.main<{ fitContent?: boolean }>`
  height: 100%;
  overflow-y: auto;

  ${({ fitContent }) =>
    fitContent &&
    `
    scrollbar-width: thin;

    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
    }
  `}
`

const StBottomSheetDraggableArea = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 3rem;
  margin: auto;
  padding: 1rem 0;
  cursor: grab;
  touch-action: none;
`

const StBottomSheetDraggableThumb = styled.div`
  width: inherit;
  height: 0.25rem;
  background: ${({ theme }) => theme.Colors.Neutrals.Light};
  border-radius: ${({ theme }) => theme.UI.BorderRadius.Small}px;
`

const StBottomSheetCloseButton = styled.div<{ draggable?: boolean }>`
  position: absolute;
  right: 0;
  top: ${({ theme }) => theme.UI.SpacingPx.Space2};
  z-index: 100;

  ${ContentPagePaddingCSS}

  display: flex;
  align-items: center;
  flex-direction: row;
  gap: ${({ theme }) => theme.UI.SpacingPx.Space2};
  cursor: pointer;
`

const StBottomSheetContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  visibility: visible;
  transition:
    opacity 0.25s,
    visibility 0.25s;
  justify-content: flex-end;

  &[aria-hidden='true'] {
    opacity: 0;
    visibility: hidden;
    pointer-events: none;

    ${StBottomSheetContentContainer} {
      transform: translateY(100%);
    }
  }
`

export {
  StBottomSheetBackdrop,
  StBottomSheetCloseButton,
  StBottomSheetContainer,
  StBottomSheetContent,
  StBottomSheetContentContainer,
  StBottomSheetDraggableArea,
  StBottomSheetDraggableThumb,
}
